import { useLayoutEffect, useRef } from "react";

// The panel uses column-reverse: zero is the latest end, and history has a
// negative scrollTop. Do not use scrollHeight as a bottom coordinate here.
export default function useThreadScroll(panelRef, threadId, messages) {
  const previous = useRef({});
  const pinned = useRef(true);
  const lastMessage = messages[messages.length - 1];
  const latestKey =
    lastMessage?.client_message_id ??
    lastMessage?.message_id ?? lastMessage?.created_at;

  useLayoutEffect(() => {
    const panel = panelRef.current;
    if (!panel) return;
    const changedThread = previous.current.threadId !== threadId;
    const changedLatest = previous.current.latestKey !== latestKey;
    if (changedThread || changedLatest) {
      pinned.current = true;
      panel.scrollTop = 0;
    }
    previous.current = { threadId, latestKey };

    const followLatest = () => {
      if (pinned.current) panel.scrollTop = 0;
    };
    const onScroll = () => {
      pinned.current = Math.abs(panel.scrollTop) < 2;
    };
    // Images and other late layout changes must not hide a message that was
    // just revealed. Stop following as soon as the user scrolls into history.
    const observer =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(followLatest);
    if (panel.firstElementChild) observer?.observe(panel.firstElementChild);
    observer?.observe(panel);
    panel.addEventListener("scroll", onScroll);
    panel.addEventListener("load", followLatest, true);
    return () => {
      observer?.disconnect();
      panel.removeEventListener("scroll", onScroll);
      panel.removeEventListener("load", followLatest, true);
    };
  }, [panelRef, threadId, latestKey, messages]);
}
